import { __decorate } from 'tslib';
import { ɵɵdefineInjectable, Injectable, Input, TemplateRef, ViewContainerRef, Directive, ElementRef, Injector, HostBinding, ViewChild, ContentChildren, Component, EventEmitter, Output, HostListener, forwardRef, NgModule } from '@angular/core';
import { NgControl, NgModel, NG_VALUE_ACCESSOR, NG_VALIDATORS, NgForm, FormControlName, FormsModule, ReactiveFormsModule } from '@angular/forms';
import 'reflect-metadata';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from '@ngx-translate/core';

function NgxDropdownForComponent_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.placeHolder, " ");
} }
function NgxDropdownForComponent_ng_container_2_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngValue", item_r5[ctx_r4.key]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r5[ctx_r4.text], " ");
} }
function NgxDropdownForComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NgxDropdownForComponent_ng_container_2_option_1_Template, 2, 2, "option", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.itemSource);
} }
function NgxDropdownForComponent_ng_template_3_option_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngValue", item_r7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r7[ctx_r6.text], " ");
} }
function NgxDropdownForComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NgxDropdownForComponent_ng_template_3_option_0_Template, 2, 2, "option", 5);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.itemSource);
} }
const _c0 = function () { return { "color": "red" }; };
function NgxFormForReactiveComponent_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "ngx-label-for", 7)(2, "ngx-input-for", 8)(3, "ngx-validator-for", 9);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    let tmp_6_0;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("model", ctx_r3._model)("field", item_r2.field)("ngClass", ctx_r3.cssClasses ? ctx_r3.cssClasses.label : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", item_r2.field)("model", ctx_r3._model)("ngClass", ctx_r3.cssClasses ? ctx_r3.cssClasses.input : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("errors", (tmp_6_0 = ctx_r3._formGroup.get(item_r2.field)) == null ? null : tmp_6_0.errors)("ngClass", ctx_r3.cssClasses ? ctx_r3.cssClasses.error : "");
} }
const _c1 = function (a0, a1) { return { model: a0, form: a1 }; };
const _c2 = function (a0) { return { $implicit: a0 }; };
function NgxFormForReactiveComponent_div_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "input", 10);
    ɵngcc0.ɵɵelementContainer(1, 11);
} if (rf & 2) {
    const item_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵproperty("formControlName", item_r2.field)("ngx-validator", ctx_r5._model);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r5.getTemplate(item_r2.field))("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(7, _c2, ɵngcc0.ɵɵpureFunction2(4, _c1, ctx_r5._model, _r0)));
} }
function NgxFormForReactiveComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtemplate(1, NgxFormForReactiveComponent_div_2_ng_container_1_Template, 4, 8, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(2, NgxFormForReactiveComponent_div_2_ng_template_2_Template, 2, 9, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const _r4 = ɵngcc0.ɵɵreference(3);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.cssClasses ? ctx_r1.cssClasses.group : "ngx-form-for");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !item_r2.template)("ngIfElse", _r4);
} }
const _c3 = function (a0) { return { name: a0 }; };
function NgxFormForComponent_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "ngx-label-for", 7);
    ɵngcc0.ɵɵelementStart(2, "ngx-input-for", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function NgxFormForComponent_div_2_ng_container_1_Template_ngx_input_for_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const item_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView((ctx_r6._model[item_r2.field] = $event)); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "ngx-validator-for", 9);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("model", ctx_r3._model)("field", item_r2.field)("ngClass", (ctx_r3.cssClasses == null ? null : ctx_r3.cssClasses.label) ? ctx_r3.cssClasses == null ? null : ctx_r3.cssClasses.label : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", item_r2.field)("model", ctx_r3._model)("ngModel", ctx_r3._model[item_r2.field])("ngModelOptions", ɵngcc0.ɵɵpureFunction1(11, _c3, item_r2.field))("field", item_r2.field)("ngClass", (ctx_r3.cssClasses == null ? null : ctx_r3.cssClasses.input) ? ctx_r3.cssClasses.input : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("errors", _r0.controls[item_r2.field] == null ? null : _r0.controls[item_r2.field].errors)("ngClass", (ctx_r3.cssClasses == null ? null : ctx_r3.cssClasses.error) ? ctx_r3.cssClasses.error : "");
} }
function NgxFormForComponent_div_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function NgxFormForComponent_div_2_ng_template_2_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const item_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView((ctx_r10._model[item_r2.field] = $event)); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainer(1, 11);
} if (rf & 2) {
    const item_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵproperty("name", item_r2.field)("ngModel", ctx_r5._model[item_r2.field])("ngx-validator", ctx_r5._model);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r5.getTemplate(item_r2.field))("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(8, _c2, ɵngcc0.ɵɵpureFunction2(5, _c1, ctx_r5._model, _r0)));
} }
function NgxFormForComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtemplate(1, NgxFormForComponent_div_2_ng_container_1_Template, 4, 13, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(2, NgxFormForComponent_div_2_ng_template_2_Template, 2, 10, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const _r4 = ɵngcc0.ɵɵreference(3);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", (ctx_r1.cssClasses == null ? null : ctx_r1.cssClasses.group) ? ctx_r1.cssClasses.group : "ngx-form-for");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !item_r2.template)("ngIfElse", _r4);
} }
function NgxInputForComponent_ng_container_1_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("href", ctx_r3.value, ɵngcc0.ɵɵsanitizeUrl)("id", ctx_r3.field);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 3, ctx_r3.name), " ");
} }
function NgxInputForComponent_ng_container_1_input_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function NgxInputForComponent_ng_container_1_input_2_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r9.value = $event); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("autocomplete", ctx_r4.autocomplete);
    ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(1, 6, ctx_r4.placeHolder))("ngModel", ctx_r4.value)("id", ctx_r4.field)("disabled", ctx_r4.disabled)("readOnly", ctx_r4.readonly);
} }
function NgxInputForComponent_ng_container_1_img_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 11);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("src", ctx_r5.value, ɵngcc0.ɵɵsanitizeUrl)("id", ctx_r5.field);
} }
function NgxInputForComponent_ng_container_1_input_4_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function NgxInputForComponent_ng_container_1_input_4_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r11.value = $event); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("autocomplete", ctx_r6.autocomplete);
    ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(1, 6, ctx_r6.placeHolder))("ngModel", ctx_r6.value)("id", ctx_r6.field)("disabled", ctx_r6.disabled)("readOnly", ctx_r6.readonly);
} }
function NgxInputForComponent_ng_container_1_textarea_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "textarea", 13);
    ɵngcc0.ɵɵlistener("ngModelChange", function NgxInputForComponent_ng_container_1_textarea_5_Template_textarea_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r13.value = $event); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(1, 5, ctx_r7.placeHolder))("ngModel", ctx_r7.value)("id", ctx_r7.field)("disabled", ctx_r7.disabled)("readOnly", ctx_r7.readonly);
} }
function NgxInputForComponent_ng_container_1_input_6_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function NgxInputForComponent_ng_container_1_input_6_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r15.value = $event); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("autocomplete", ctx_r8.autocomplete);
    ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(1, 7, ctx_r8.placeHolder))("ngModel", ctx_r8.value)("id", ctx_r8.field)("disabled", ctx_r8.disabled)("readOnly", ctx_r8.readonly)("name", ctx_r8.field);
} }
function NgxInputForComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NgxInputForComponent_ng_container_1_a_1_Template, 3, 5, "a", 3);
    ɵngcc0.ɵɵtemplate(2, NgxInputForComponent_ng_container_1_input_2_Template, 2, 8, "input", 4);
    ɵngcc0.ɵɵtemplate(3, NgxInputForComponent_ng_container_1_img_3_Template, 1, 2, "img", 5);
    ɵngcc0.ɵɵtemplate(4, NgxInputForComponent_ng_container_1_input_4_Template, 2, 8, "input", 6);
    ɵngcc0.ɵɵtemplate(5, NgxInputForComponent_ng_container_1_textarea_5_Template, 2, 7, "textarea", 7);
    ɵngcc0.ɵɵtemplate(6, NgxInputForComponent_ng_container_1_input_6_Template, 2, 9, "input", 8);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r0.DataTypeEnum.Url);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r0.DataTypeEnum.Password);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r0.DataTypeEnum.ImageUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r0.DataTypeEnum.Upload);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r0.DataTypeEnum.MultilineText);
} }
function NgxInputForComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 15);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.getTemplate())("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c2, ctx_r2.model));
} }
function NgxValidatorForComponent_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const message_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, message_r1));
} }
function NgxValidatorForComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, NgxValidatorForComponent_div_1_ng_container_1_Template, 3, 3, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", message_r1);
} }
let NgxValidatorService = class NgxValidatorService {
    constructor() {
    }
};
NgxValidatorService.ɵfac = function NgxValidatorService_Factory(t) { return new (t || NgxValidatorService)(); };
NgxValidatorService.ɵprov = ɵɵdefineInjectable({ factory: function NgxValidatorService_Factory() { return new NgxValidatorService(); }, token: NgxValidatorService, providedIn: "root" });

var DataTypeEnum;
(function (DataTypeEnum) {
    DataTypeEnum[DataTypeEnum["Int"] = 0] = "Int";
    DataTypeEnum[DataTypeEnum["Number"] = 1] = "Number";
    DataTypeEnum[DataTypeEnum["MultilineText"] = 2] = "MultilineText";
    DataTypeEnum[DataTypeEnum["Url"] = 3] = "Url";
    DataTypeEnum[DataTypeEnum["ImageUrl"] = 4] = "ImageUrl";
    DataTypeEnum[DataTypeEnum["Password"] = 5] = "Password";
    DataTypeEnum[DataTypeEnum["Hexadecimal"] = 6] = "Hexadecimal";
    DataTypeEnum[DataTypeEnum["Date"] = 7] = "Date";
    DataTypeEnum[DataTypeEnum["Array"] = 8] = "Array";
    DataTypeEnum[DataTypeEnum["Upload"] = 9] = "Upload";
})(DataTypeEnum || (DataTypeEnum = {}));

function isEmpty(obj) {
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            return false;
        }
    }
    return true;
}
// tslint:disable-next-line:callable-types
function ModelState(constructor) {
    return class extends constructor {
        /**
         * Returns model validation state
         */
        IsValid() {
            for (const item of Reflect.getMetadataKeys(this)) {
                const attribs = getDecorators(this, item);
                for (const attrib of attribs.filter(x => x.key !== 'ReadOnly' && x.key !== 'NoForm')) {
                    const messg = ngxValidate(attrib.key, attrib.value, this[item], this);
                    if (messg) {
                        return false;
                    }
                }
            }
            return true;
        }
        /**
         * Placeholder(string)
         * Validate: function
         */
        ModelErrors() {
            const errs = {};
            let tmp = {};
            for (const item of Reflect.getMetadataKeys(this)) {
                const attribs = getDecorators(this, item);
                for (const attrib of attribs.filter(x => x.key !== 'ReadOnly' && x.key !== 'NoForm')) {
                    const messg = ngxValidate(attrib.key, attrib.value, this[item], this);
                    if (messg) {
                        tmp[attrib.key] = messg;
                    }
                }
                if (!isEmpty(tmp)) {
                    errs[item] = tmp;
                }
                tmp = {};
            }
            return errs;
        }
    };
}
/**
 * Validates field if it has valid value according to value parameter
 */
function DataType(param) {
    return (target, propertyKey) => {
        Reflect.defineMetadata(propertyKey, param, target);
        Reflect.defineMetadata('custom-reflect:DataType', param, target, propertyKey);
    };
}
/**
 * Validates field if it represents valid credit card number
 */
function CreditCard(param) {
    return (target, propertyKey) => {
        Reflect.defineMetadata(propertyKey, param, target);
        Reflect.defineMetadata('custom-reflect:CreditCard', param, target, propertyKey);
    };
}
/**
 * Compares field to other field and checks if they are equal
 */
function Compare(param) {
    return (target, propertyKey) => {
        Reflect.defineMetadata(propertyKey, param, target);
        Reflect.defineMetadata('custom-reflect:Compare', param, target, propertyKey);
    };
}
/**
 * Validates if field value contains specific value
 */
function Contains(param) {
    return (target, propertyKey) => {
        Reflect.defineMetadata(propertyKey, param, target);
        Reflect.defineMetadata('custom-reflect:Contains', param, target, propertyKey);
    };
}
/**
 * Validates field according to custom logic
 */
function Custom(param) {
    return (target, propertyKey) => {
        Reflect.defineMetadata(propertyKey, param, target);
        Reflect.defineMetadata('custom-reflect:Custom', param, target, propertyKey);
    };
}
/**
 * Sets the name metadata for the field
 */
function Name(param) {
    return (target, propertyKey) => {
        Reflect.defineMetadata(propertyKey, param, target);
        Reflect.defineMetadata('custom-reflect:Name', param, target, propertyKey);
    };
}
/**
 * Validates field and checks if it has null, undefined or empty value
 */
function Required(param) {
    return (target, propertyKey) => {
        Reflect.defineMetadata(propertyKey, param, target);
        Reflect.defineMetadata('custom-reflect:Required', param, target, propertyKey);
    };
}
/**
 * Validates field if other field has specific value and checks if it has null, undefined or empty value
 */
function RequiredIf(param) {
    return (target, propertyKey) => {
        Reflect.defineMetadata(propertyKey, param, target);
        Reflect.defineMetadata('custom-reflect:RequiredIf', param, target, propertyKey);
    };
}
/**
 * Sets field's input value to readonly
 */
function ReadOnly() {
    return (target, propertyKey) => {
        Reflect.defineMetadata(propertyKey, propertyKey, target);
        Reflect.defineMetadata('custom-reflect:ReadOnly', null, target, propertyKey);
    };
}
/**
 * Validates if field has valid value according to specified pattern
 */
function Pattern(param) {
    return (target, propertyKey) => {
        Reflect.defineMetadata(propertyKey, param, target);
        Reflect.defineMetadata('custom-reflect:Pattern', param, target, propertyKey);
    };
}
/**
 * Validates if field has valid value more than specific value
 */
function MinValue(input) {
    return (target, propertyKey) => {
        Reflect.defineMetadata(propertyKey, input, target);
        Reflect.defineMetadata('custom-reflect:MinValue', input, target, propertyKey);
    };
}
/**
 * Validates if field has valid value less than specific value
 */
function MaxValue(input) {
    return (target, propertyKey) => {
        Reflect.defineMetadata(propertyKey, input, target);
        Reflect.defineMetadata('custom-reflect:MaxValue', input, target, propertyKey);
    };
}
/**
 * Validates if field value does not contain specific value
 */
function NotContains(param) {
    return (target, propertyKey) => {
        Reflect.defineMetadata(propertyKey, param, target);
        Reflect.defineMetadata('custom-reflect:NotContains', param, target, propertyKey);
    };
}
/**
 * Tells form generator component not to generate input for this field
 */
function NoForm() {
    return (target, propertyKey) => {
        Reflect.defineMetadata(propertyKey, propertyKey, target);
        Reflect.defineMetadata('custom-reflect:NoForm', null, target, propertyKey);
    };
}
/**
 * Validates if field value length fits in min and max values
 */
function StringLength(input) {
    return (target, propertyKey) => {
        Reflect.defineMetadata(propertyKey, input, target);
        Reflect.defineMetadata('custom-reflect:StringLength', input, target, propertyKey);
    };
}
/**
 * Validates if field value is valid email value
 */
function Email(input) {
    return (target, propertyKey) => {
        Reflect.defineMetadata(propertyKey, input, target);
        Reflect.defineMetadata('custom-reflect:Email', input, target, propertyKey);
    };
}
/**
 * Sets placeholder value for field input
 */
function Placeholder(input) {
    return (target, propertyKey) => {
        Reflect.defineMetadata(propertyKey, input, target);
        Reflect.defineMetadata('custom-reflect:Placeholder', input, target, propertyKey);
    };
}
/**
 * Validates if field value length fits in min and max values
 */
function Range(input) {
    return (target, propertyKey) => {
        Reflect.defineMetadata(propertyKey, input, target);
        Reflect.defineMetadata('custom-reflect:Range', input, target, propertyKey);
    };
}
function configurable(value) {
    return (target, propertyKey, descriptor) => {
        descriptor.configurable = value;
    };
}
/**
 * Placeholder(string)
 * Validate: function
 */
function getDecorators(target, propertyName) {
    const keys = Reflect.getMetadataKeys(target, propertyName);
    const decorators = keys.filter(key => key.toString().startsWith('custom-reflect:'))
        .reduce((values, key) => {
        const value = Reflect.getMetadata(key, target, propertyName);
        return values.concat({ key: key.toString().replace('custom-reflect:', ''), value });
    }, []);
    return decorators;
}
function ngxValidate(key, param, value, dataModel) {
    let retstr;
    if ((value === null || value === undefined || value === '') && key !== 'Required' && key !== 'RequiredIf'
        && key !== 'Compare' && key !== 'Range') {
        return null;
    }
    let errorString = '';
    if (typeof param === 'string') {
        errorString = param;
    }
    else {
        errorString = param.error;
    }
    if (!errorString) {
        errorString = 'error not asigned!';
    }
    switch (key) {
        case 'CreditCard': {
            value = value.replace(/[- ]+/g, '');
            const Visa = /^4[0-9]{12}(?:[0-9]{3})?$/;
            const MasterCard = /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/;
            const Amex = /^3[47][0-9]{13}$/;
            const DinersClub = /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/;
            const Discover = /^6(?:011|5[0-9]{2})[0-9]{12}$/;
            const JCB = /^(?:2131|1800|35\d{3})\d{11}$/;
            const BCGlobal = /^(6541|6556)[0-9]{12}$/;
            const CarteBlanche = /^389[0-9]{11}$/;
            const InstaPayment = /^63[7-9][0-9]{13}$/;
            const KoreanLocalCard = /^9[0-9]{15}$/;
            const Laser = /^(6304|6706|6709|6771)[0-9]{12,15}$/;
            const Maestro = /^(5018|5020|5038|6304|6759|6761|6763)[0-9]{8,15}$/;
            const Solo = /^(6334|6767)[0-9]{12}|(6334|6767)[0-9]{14}|(6334|6767)[0-9]{15}$/;
            // tslint:disable-next-line:max-line-length
            const Switch = /^(4903|4905|4911|4936|6333|6759)[0-9]{12}|(4903|4905|4911|4936|6333|6759)[0-9]{14}|(4903|4905|4911|4936|6333|6759)[0-9]{15}|564182[0-9]{10}|564182[0-9]{12}|564182[0-9]{13}|633110[0-9]{10}|633110[0-9]{12}|633110[0-9]{13}$/;
            const UnionPay = /^(62[0-9]{14,17})$/;
            if (!checkLuhn(value) ||
                !(Visa.test(value) || MasterCard.test(value) || Amex.test(value) || DinersClub.test(value)
                    || Discover.test(value) || JCB.test(value) || BCGlobal.test(value) || CarteBlanche.test(value)
                    || InstaPayment.test(value) || KoreanLocalCard.test(value) || Laser.test(value)
                    || Maestro.test(value) || Solo.test(value) || Switch.test(value) || UnionPay.test(value) ||
                    (param.customValue && param.customValue.test(value)))) {
                retstr = param.error;
            }
            break;
        }
        case 'Compare': {
            if (value !== dataModel[param.field]) {
                retstr = errorString;
            }
            break;
        }
        case 'Contains': {
            if (value.indexOf(param.value) === -1) {
                retstr = errorString;
            }
            break;
        }
        case 'Custom': {
            const result = param.customFunc(value, dataModel);
            if (!result) {
                retstr = errorString;
            }
            break;
        }
        case 'DataType': {
            if (param.value === DataTypeEnum.Number) {
                const reg = /^[+-]?\d+(\.\d+)?$/;
                if (isNaN(parseFloat(value)) || !reg.test(value)) {
                    retstr = errorString;
                }
            }
            if (param.value === DataTypeEnum.Date) {
                if (!(value instanceof Date)) {
                    retstr = errorString;
                }
            }
            if (param.value === DataTypeEnum.Hexadecimal) {
                const expression = /^([0-9a-fA-F]+)$/i;
                if (!expression.test(value)) {
                    retstr = errorString;
                }
            }
            if (param.value === DataTypeEnum.Int) {
                const reg = /^[+\-]?\d+$/;
                if (isNaN(parseFloat(value))
                    || !isNaN(parseFloat(value)) && (parseFloat(value) - parseInt(value, 10) !== 0)
                    || !reg.test(value)) {
                    retstr = errorString;
                }
            }
            if (param.value === DataTypeEnum.Array) {
                if (!Array.isArray(value)) {
                    retstr = errorString;
                }
            }
            break;
        }
        case 'NotContains': {
            if (value.indexOf(param.value) !== -1) {
                retstr = errorString;
            }
            break;
        }
        case 'Required': {
            if (value === null || value === undefined || value === '') {
                retstr = errorString;
            }
            break;
        }
        case 'RequiredIf': {
            if (!param.field || !param.value) {
                console.warn('incorrect parameters in RequiredIf attribute');
            }
            else {
                if ((param.value === dataModel[param.field])
                    && (value === null || value === undefined || value === '')) {
                    retstr = errorString;
                }
            }
            break;
        }
        case 'Pattern': {
            const pat = param.value;
            if (!pat.test(value)) {
                retstr = errorString;
            }
            break;
        }
        case 'MinValue': {
            if (value < param.value) {
                retstr = errorString.replace('{0}', param.value.toString());
            }
            break;
        }
        case 'MaxValue': {
            if (value > param.value) {
                retstr = errorString.replace('{0}', param.value.toString());
            }
            break;
        }
        case 'StringLength': {
            if (!value || value.length < param.min || value.length > param.max) {
                retstr = errorString.replace('{0}', param.min
                    .toString())
                    .replace('{1}', param.max.toString());
            }
            break;
        }
        case 'Range': {
            if (value < param.min || value > param.max) {
                retstr = errorString.replace('{0}', param.min
                    .toString())
                    .replace('{1}', param.max.toString());
            }
            break;
        }
        case 'Email': {
            // credits http://emailregex.com/
            // tslint:disable-next-line:max-line-length
            const emreg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!emreg.test(value)) {
                retstr = errorString;
            }
            break;
        }
        default: {
            retstr = null;
            break;
        }
    }
    return retstr;
}
function checkLuhn(value) {
    // credits https://github.com/JamesEggers1/node-luhn
    const trimmed = String(value).replace(/[\s]/g, '');
    const length = trimmed.length;
    let odd = false;
    let total = 0;
    let calc;
    let calc2;
    if (length === 0) {
        return true;
    }
    if (!/^[0-9]+$/.test(trimmed)) {
        return false;
    }
    for (let i = length; i > 0; i--) {
        calc = parseInt(trimmed.charAt(i - 1), 10);
        if (!odd) {
            total += calc;
        }
        else {
            calc2 = calc * 2;
            switch (calc2) {
                case 10:
                    calc2 = 1;
                    break;
                case 12:
                    calc2 = 3;
                    break;
                case 14:
                    calc2 = 5;
                    break;
                case 16:
                    calc2 = 7;
                    break;
                case 18:
                    calc2 = 9;
                    break;
                default: calc2 = calc2;
            }
            total += calc2;
        }
        odd = !odd;
    }
    return (total !== 0 && (total % 10) === 0);
}

// credits to https://github.com/clbond/form-example
class ValueAccessorBase {
    constructor(theInjector) {
        this.theInjector = theInjector;
        this.onChange = null;
        this.onTouch = null;
    }
    get formControl() {
        if (this.control != null) {
            return this.control;
        }
        this.control = this.theInjector.get(NgControl, null);
        return this.control;
    }
    get value() {
        return this.innerValue;
    }
    set value(value) {
        if (this.innerValue !== value) {
            this.innerValue = value;
            if (this.onChange) {
                this.onChange(value);
            }
        }
    }
    writeValue(value) {
        this.innerValue = value;
        if (this.onChange) {
            this.onChange(value);
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(disabled) {
        this.disabled = disabled;
    }
    touch() {
        if (this.onTouch) {
            this.onTouch();
        }
    }
}

function validateControl(control, dataModel) {
    let name;
    if (control.parent) {
        for (const item of Object.keys(control.parent.controls)) {
            if (control.parent.controls[item] === control) {
                name = item;
            }
        }
    }
    else {
        name = this.field;
    }
    const attribs = getDecorators(dataModel, name);
    const errs = {};
    if (attribs.find(x => x.key === 'ReadOnly')) {
        this.el.nativeElement.setAttribute('readonly', true);
    }
    for (const item of attribs.filter(x => x.key !== 'ReadOnly' && x.key !== 'NoForm')) {
        const messg = ngxValidate(item.key, item.value, control.value, dataModel);
        if (messg) {
            errs[item.key] = messg;
        }
    }
    return errs;
}

class ElementBase extends ValueAccessorBase {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.validator = validateControl;
    }
    validate(control) {
        return this.validator(control, this.model);
    }
}
ElementBase.ɵfac = function ElementBase_Factory(t) { ɵngcc0.ɵɵinvalidFactory(); };
ElementBase.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ElementBase, inputs: { model: "model" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    Input()
], ElementBase.prototype, "model", void 0);

let NgxCustomTemplateForDirective = class NgxCustomTemplateForDirective {
    constructor(templateRef, viewContainer) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
    }
};
NgxCustomTemplateForDirective.ɵfac = function NgxCustomTemplateForDirective_Factory(t) { return new (t || NgxCustomTemplateForDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
NgxCustomTemplateForDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxCustomTemplateForDirective, selectors: [["", "ngxCustomTemplateFor", ""]], inputs: { ngxCustomTemplateFor: "ngxCustomTemplateFor" } });
NgxCustomTemplateForDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef }
];
__decorate([
    Input()
], NgxCustomTemplateForDirective.prototype, "ngxCustomTemplateFor", void 0);

var NgxDropdownForComponent_1;
let NgxDropdownForComponent = NgxDropdownForComponent_1 = class NgxDropdownForComponent extends ElementBase {
    constructor(el, injector) {
        super(injector);
        this.el = el;
        this.injector = injector;
        this.DataTypeEnum = DataTypeEnum;
        this.placeHolder = '';
        this.name = '';
        this.readonly = false;
        this.ngxDropdown = true;
        this.itemSource = [];
        this.valuePrimitive = true;
        this.defaultItem = true;
    }
    set templates(value) {
        if (this.model) {
            value.forEach((item) => {
                this.template = item;
            });
        }
    }
    ngOnInit() {
        if (!this.model) {
            console.error('ngx-validator error! [model] property is not binded!');
        }
        if (this.field === null || this.field === undefined) {
            this.field = this.el.nativeElement.getAttribute('name') === null
                ? this.el.nativeElement.getAttribute('id')
                : this.el.nativeElement.getAttribute('name');
        }
        if (!this.field) {
            this.field = this.el.nativeElement.getAttribute('formControlName');
        }
        const attribs = getDecorators(this.model, this.field);
        if (attribs.find(x => x.key === 'Placeholder')) {
            this.placeHolder = attribs.find(x => x.key === 'Placeholder').value;
        }
        if (attribs.find(x => x.key === 'ReadOnly')) {
            this.readonly = true;
        }
        if (attribs.find(x => x.key === 'Name')) {
            this.name = attribs.find(x => x.key === 'Name').value;
        }
        else {
            this.name = this.field;
        }
    }
};
NgxDropdownForComponent.ɵfac = function NgxDropdownForComponent_Factory(t) { return new (t || NgxDropdownForComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
NgxDropdownForComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxDropdownForComponent, selectors: [["ngx-dropdown-for"]], contentQueries: function NgxDropdownForComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgxCustomTemplateForDirective, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templates = _t);
    } }, viewQuery: function NgxDropdownForComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgModel, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.ngModel = _t.first);
    } }, hostVars: 2, hostBindings: function NgxDropdownForComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("ngx-dropdown", ctx.ngxDropdown);
    } }, inputs: { itemSource: "itemSource", valuePrimitive: "valuePrimitive", defaultItem: "defaultItem", field: "field", key: "key", text: "text" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: NG_VALUE_ACCESSOR, useExisting: NgxDropdownForComponent_1, multi: true },
            { provide: NG_VALIDATORS, useExisting: NgxDropdownForComponent_1, multi: true }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 6, consts: [[1, "ngx-dropdown-child", 3, "ngModel", "ngStyle", "ngModelChange"], ["value", "undefined", "disabled", "", "class", "ngx-dropdown-child-default", "selected", "", "hidden", "", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["nonPrimitve", ""], ["value", "undefined", "disabled", "", "selected", "", "hidden", "", 1, "ngx-dropdown-child-default"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"]], template: function NgxDropdownForComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "select", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function NgxDropdownForComponent_Template_select_ngModelChange_0_listener($event) { return ctx.value = $event; });
        ɵngcc0.ɵɵtemplate(1, NgxDropdownForComponent_option_1_Template, 2, 1, "option", 1);
        ɵngcc0.ɵɵtemplate(2, NgxDropdownForComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(3, NgxDropdownForComponent_ng_template_3_Template, 1, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.value)("ngStyle", ɵngcc0.ɵɵpureFunction0(5, _c0));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.defaultItem);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.valuePrimitive)("ngIfElse", _r2);
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgStyle, ɵngcc2.NgSelectOption, ɵngcc2.ɵNgSelectMultipleOption, ɵngcc2.SelectControlValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel], encapsulation: 2 });
NgxDropdownForComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Injector }
];
__decorate([
    HostBinding('class.ngx-dropdown')
], NgxDropdownForComponent.prototype, "ngxDropdown", void 0);
__decorate([
    Input()
], NgxDropdownForComponent.prototype, "itemSource", void 0);
__decorate([
    Input()
], NgxDropdownForComponent.prototype, "field", void 0);
__decorate([
    Input()
], NgxDropdownForComponent.prototype, "key", void 0);
__decorate([
    Input()
], NgxDropdownForComponent.prototype, "valuePrimitive", void 0);
__decorate([
    Input()
], NgxDropdownForComponent.prototype, "text", void 0);
__decorate([
    ViewChild(NgModel, { static: false })
], NgxDropdownForComponent.prototype, "ngModel", void 0);
__decorate([
    Input()
], NgxDropdownForComponent.prototype, "defaultItem", void 0);
__decorate([
    ContentChildren(NgxCustomTemplateForDirective, { descendants: false })
], NgxDropdownForComponent.prototype, "templates", null);

let NgxFormForReactiveComponent = class NgxFormForReactiveComponent {
    constructor() {
        this.propertyNames = [];
        this.submitForm = new EventEmitter();
        // tslint:disable-next-line:variable-name
        this._templates = [];
    }
    set model(value) {
        this._model = value;
    }
    set formGroup(value) {
        this._formGroup = value;
        for (const item of Object.keys(this._model)) {
            const attribs = getDecorators(this._model, item);
            if (!attribs.find(x => x.key === 'NoForm') && this._formGroup.controls[item]) {
                this.propertyNames.push({ field: item, template: false });
            }
        }
    }
    set templates(value) {
        if (this._model) {
            value.forEach((item) => {
                if (this.propertyNames.find(x => x.field === item.ngxCustomTemplateFor)) {
                    this._templates.push(item);
                    this.propertyNames.find(x => x.field === item.ngxCustomTemplateFor).template = true;
                }
                else {
                    throw (new Error(`Property name bound on NgxCustomTemplateForDirective ${item.ngxCustomTemplateFor} not found.
           If it is definity correct, please check if you have initialized it before passing model to ngx-form-for component`));
                }
            });
        }
    }
    ngOnInit() {
    }
    getTemplate(field) {
        return this._templates.find(x => x.ngxCustomTemplateFor === field).templateRef;
    }
    submit() {
        this.submitForm.emit(this._model);
    }
    controlExists(item) {
        if (this.formGroup.controls[item]) {
            return true;
        }
        else {
            return false;
        }
    }
};
NgxFormForReactiveComponent.ɵfac = function NgxFormForReactiveComponent_Factory(t) { return new (t || NgxFormForReactiveComponent)(); };
NgxFormForReactiveComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxFormForReactiveComponent, selectors: [["ngx-form-for-reactive"]], contentQueries: function NgxFormForReactiveComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgxCustomTemplateForDirective, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templates = _t);
    } }, viewQuery: function NgxFormForReactiveComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgForm, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.form = _t.first);
    } }, inputs: { model: "model", formGroup: "formGroup", cssClasses: "cssClasses", autoComplete: "autoComplete" }, outputs: { submitForm: "submitForm" }, decls: 5, vars: 4, consts: [[3, "autocomplete", "formGroup", "ngSubmit"], ["form", "ngForm"], [3, "ngClass", 4, "ngFor", "ngForOf"], ["type", "submit", 1, "btn", "btn-success", 3, "disabled"], [3, "ngClass"], [4, "ngIf", "ngIfElse"], ["template", ""], [3, "model", "field", "ngClass"], [3, "formControlName", "model", "ngClass"], [3, "errors", "ngClass"], [2, "display", "none", 3, "formControlName", "ngx-validator"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function NgxFormForReactiveComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0, 1);
        ɵngcc0.ɵɵlistener("ngSubmit", function NgxFormForReactiveComponent_Template_form_ngSubmit_0_listener() { return ctx.submit(); });
        ɵngcc0.ɵɵtemplate(2, NgxFormForReactiveComponent_div_2_Template, 4, 3, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "button", 3);
        ɵngcc0.ɵɵtext(4, " Submit ");
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        ɵngcc0.ɵɵproperty("autocomplete", ctx.autoComplete)("formGroup", ctx._formGroup);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.propertyNames);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", _r0.invalid);
    } }, dependencies: function () { return [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc2.ɵNgNoValidate, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc2.FormControlName, NgxValidatorDirective, NgxValidatorForComponent, NgxLabelForComponent, NgxInputForComponent]; }, encapsulation: 2 });
__decorate([
    Input()
], NgxFormForReactiveComponent.prototype, "cssClasses", void 0);
__decorate([
    Input()
], NgxFormForReactiveComponent.prototype, "model", null);
__decorate([
    Input()
], NgxFormForReactiveComponent.prototype, "formGroup", null);
__decorate([
    Input()
], NgxFormForReactiveComponent.prototype, "autoComplete", void 0);
__decorate([
    ViewChild(NgForm, { static: false })
], NgxFormForReactiveComponent.prototype, "form", void 0);
__decorate([
    Output()
], NgxFormForReactiveComponent.prototype, "submitForm", void 0);
__decorate([
    ContentChildren(NgxCustomTemplateForDirective, { descendants: false })
], NgxFormForReactiveComponent.prototype, "templates", null);

let NgxFormForComponent = class NgxFormForComponent {
    constructor() {
        this.propertyNames = [];
        this.submitForm = new EventEmitter();
        // tslint:disable-next-line:variable-name
        this._templates = [];
    }
    set model(value) {
        this._model = value;
        for (const item of Object.keys(this._model)) {
            const attribs = getDecorators(this._model, item);
            if (!attribs.find(x => x.key === 'NoForm')) {
                this.propertyNames.push({ field: item, template: false });
            }
        }
        for (const item of Reflect.getMetadataKeys(this._model)) {
            const attribs = getDecorators(this._model, item);
            if (!attribs.find(x => x.key === 'NoForm') && this.propertyNames.find(x => x.field === item) === undefined) {
                this.propertyNames.push({ field: item, template: false });
            }
        }
    }
    set templates(value) {
        if (this._model) {
            value.forEach((item) => {
                if (this.propertyNames.find(x => x.field === item.ngxCustomTemplateFor)) {
                    this._templates.push(item);
                    this.propertyNames.find(x => x.field === item.ngxCustomTemplateFor).template = true;
                }
                else {
                    throw (new Error(`Property name bound on NgxCustomTemplateForDirective ${item.ngxCustomTemplateFor} not found.
           If it is definity correct, please check if you have initialized it before passing model to ngx-form-for component`));
                }
            });
        }
    }
    ngOnInit() {
    }
    getTemplate(field) {
        return this._templates.find(x => x.ngxCustomTemplateFor === field).templateRef;
    }
    submit() {
        this.submitForm.emit(this._model);
    }
};
NgxFormForComponent.ɵfac = function NgxFormForComponent_Factory(t) { return new (t || NgxFormForComponent)(); };
NgxFormForComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxFormForComponent, selectors: [["ngx-form-for"]], contentQueries: function NgxFormForComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgxCustomTemplateForDirective, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templates = _t);
    } }, viewQuery: function NgxFormForComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgForm, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.form = _t.first);
    } }, inputs: { model: "model", cssClasses: "cssClasses", autoComplete: "autoComplete" }, outputs: { submitForm: "submitForm" }, decls: 5, vars: 3, consts: [[3, "autocomplete", "ngSubmit"], ["form", "ngForm"], [3, "ngClass", 4, "ngFor", "ngForOf"], ["type", "submit", 1, "btn", "btn-success", 3, "disabled"], [3, "ngClass"], [4, "ngIf", "ngIfElse"], ["template", ""], [3, "model", "field", "ngClass"], [3, "id", "model", "ngModel", "ngModelOptions", "field", "ngClass", "ngModelChange"], [3, "errors", "ngClass"], [2, "display", "none", 3, "name", "ngModel", "ngx-validator", "ngModelChange"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function NgxFormForComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0, 1);
        ɵngcc0.ɵɵlistener("ngSubmit", function NgxFormForComponent_Template_form_ngSubmit_0_listener() { return ctx.submit(); });
        ɵngcc0.ɵɵtemplate(2, NgxFormForComponent_div_2_Template, 4, 3, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "button", 3);
        ɵngcc0.ɵɵtext(4, " Submit ");
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        ɵngcc0.ɵɵproperty("autocomplete", ctx.autoComplete);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.propertyNames);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", _r0.invalid);
    } }, dependencies: function () { return [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc2.ɵNgNoValidate, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgControlStatusGroup, ɵngcc2.NgModel, ɵngcc2.NgForm, NgxValidatorDirective, NgxValidatorForComponent, NgxLabelForComponent, NgxInputForComponent]; }, encapsulation: 2 });
__decorate([
    Input()
], NgxFormForComponent.prototype, "model", null);
__decorate([
    Input()
], NgxFormForComponent.prototype, "cssClasses", void 0);
__decorate([
    Input()
], NgxFormForComponent.prototype, "autoComplete", void 0);
__decorate([
    ViewChild(NgForm, { static: false })
], NgxFormForComponent.prototype, "form", void 0);
__decorate([
    Output()
], NgxFormForComponent.prototype, "submitForm", void 0);
__decorate([
    ContentChildren(NgxCustomTemplateForDirective, { descendants: false })
], NgxFormForComponent.prototype, "templates", null);

var NgxInputForComponent_1;
let NgxInputForComponent = NgxInputForComponent_1 = class NgxInputForComponent extends ElementBase {
    constructor(el, injector) {
        super(injector);
        this.el = el;
        this.injector = injector;
        this.DataTypeEnum = DataTypeEnum;
        this.placeHolder = '';
        this.name = '';
        this.blurEvent = new EventEmitter();
        this.readonly = false;
        this.ngxInput = true;
    }
    onFocusout() {
        this.blurEvent.emit();
    }
    set templates(value) {
        if (this.model) {
            value.forEach((item) => {
                this._template = item;
            });
        }
    }
    ngOnInit() {
        if (!this.model) {
            console.error('ngx-validator error! [model] property is not binded!');
        }
        if (this.field === null || this.field === undefined) {
            this.field = this.el.nativeElement.getAttribute('name') === null
                ? this.el.nativeElement.getAttribute('id')
                : this.el.nativeElement.getAttribute('name');
        }
        if (!this.field) {
            this.field = this.el.nativeElement.getAttribute('formControlName');
        }
        this.autocomplete = this.el.nativeElement.getAttribute('autocomplete');
        const attribs = getDecorators(this.model, this.field);
        if (attribs.find(x => x.key === 'DataType')) {
            this.dataType = attribs.find(x => x.key === 'DataType').value.value;
        }
        if (attribs.find(x => x.key === 'Placeholder')) {
            this.placeHolder = attribs.find(x => x.key === 'Placeholder').value;
        }
        if (attribs.find(x => x.key === 'ReadOnly')) {
            this.readonly = true;
        }
        if (attribs.find(x => x.key === 'Name')) {
            this.name = attribs.find(x => x.key === 'Name').value;
        }
        else {
            this.name = this.field;
        }
    }
    getTemplate() {
        return this._template.templateRef;
    }
};
NgxInputForComponent.ɵfac = function NgxInputForComponent_Factory(t) { return new (t || NgxInputForComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
NgxInputForComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxInputForComponent, selectors: [["ngx-input-for"]], contentQueries: function NgxInputForComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgxCustomTemplateForDirective, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templates = _t);
    } }, viewQuery: function NgxInputForComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgModel, 5);
        ɵngcc0.ɵɵviewQuery(FormControlName, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.ngModel = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.formControlName = _t.first);
    } }, hostVars: 2, hostBindings: function NgxInputForComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focusout", function NgxInputForComponent_focusout_HostBindingHandler() { return ctx.onFocusout(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("ngx-input", ctx.ngxInput);
    } }, inputs: { field: "field", dataItems: "dataItems" }, outputs: { blurEvent: "blurEvent" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => NgxInputForComponent_1), multi: true },
            { provide: NG_VALIDATORS, useExisting: NgxInputForComponent_1, multi: true }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 3, consts: [[3, "ngSwitch"], [4, "ngIf", "ngIfElse"], ["template", ""], ["class", "ngx-input-child-url", 3, "href", "id", 4, "ngSwitchCase"], ["type", "password", "class", "ngx-input-child", 3, "placeholder", "ngModel", "id", "autocomplete", "disabled", "readOnly", "ngModelChange", 4, "ngSwitchCase"], ["class", "ngx-input-child-image", 3, "src", "id", 4, "ngSwitchCase"], ["type", "file", "class", "ngx-input-child-upload", 3, "placeholder", "ngModel", "id", "autocomplete", "disabled", "readOnly", "ngModelChange", 4, "ngSwitchCase"], ["class", "ngx-input-child-textarea", "rows", "5", 3, "placeholder", "ngModel", "id", "disabled", "readOnly", "ngModelChange", 4, "ngSwitchCase"], ["type", "text", "class", "ngx-input-child", 3, "placeholder", "ngModel", "autocomplete", "id", "disabled", "readOnly", "name", "ngModelChange", 4, "ngSwitchDefault"], [1, "ngx-input-child-url", 3, "href", "id"], ["type", "password", 1, "ngx-input-child", 3, "placeholder", "ngModel", "id", "autocomplete", "disabled", "readOnly", "ngModelChange"], [1, "ngx-input-child-image", 3, "src", "id"], ["type", "file", 1, "ngx-input-child-upload", 3, "placeholder", "ngModel", "id", "autocomplete", "disabled", "readOnly", "ngModelChange"], ["rows", "5", 1, "ngx-input-child-textarea", 3, "placeholder", "ngModel", "id", "disabled", "readOnly", "ngModelChange"], ["type", "text", 1, "ngx-input-child", 3, "placeholder", "ngModel", "autocomplete", "id", "disabled", "readOnly", "name", "ngModelChange"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function NgxInputForComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, NgxInputForComponent_ng_container_1_Template, 7, 5, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, NgxInputForComponent_ng_template_2_Template, 1, 4, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.dataType);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx._template)("ngIfElse", _r1);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc1.NgSwitchDefault, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, ɵngcc3.TranslatePipe], encapsulation: 2 });
NgxInputForComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Injector }
];
__decorate([
    Input()
], NgxInputForComponent.prototype, "dataItems", void 0);
__decorate([
    Output()
], NgxInputForComponent.prototype, "blurEvent", void 0);
__decorate([
    Input()
], NgxInputForComponent.prototype, "field", void 0);
__decorate([
    ViewChild(NgModel, { static: false })
], NgxInputForComponent.prototype, "ngModel", void 0);
__decorate([
    ViewChild(FormControlName, { static: false })
], NgxInputForComponent.prototype, "formControlName", void 0);
__decorate([
    HostBinding('class.ngx-input')
], NgxInputForComponent.prototype, "ngxInput", void 0);
__decorate([
    HostListener('focusout')
], NgxInputForComponent.prototype, "onFocusout", null);
__decorate([
    ContentChildren(NgxCustomTemplateForDirective, { descendants: false })
], NgxInputForComponent.prototype, "templates", null);

let NgxLabelForComponent = class NgxLabelForComponent {
    constructor() {
        this.ngxLabel = true;
        this.reflectValue = '';
    }
    ngOnInit() {
        try {
            this.reflectValue = getDecorators(this.model, this.field).find(x => x.key === 'Name').value;
        }
        catch (_a) {
            this.reflectValue = this.field;
        }
    }
};
NgxLabelForComponent.ɵfac = function NgxLabelForComponent_Factory(t) { return new (t || NgxLabelForComponent)(); };
NgxLabelForComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxLabelForComponent, selectors: [["ngx-label-for"]], hostVars: 2, hostBindings: function NgxLabelForComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("ngx-label", ctx.ngxLabel);
    } }, inputs: { model: "model", field: "field" }, decls: 3, vars: 4, consts: [[1, "ngx-label-child", 3, "for"]], template: function NgxLabelForComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("for", ctx.field);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 2, ctx.reflectValue), "\n");
    } }, dependencies: [ɵngcc3.TranslatePipe], encapsulation: 2 });
__decorate([
    Input()
], NgxLabelForComponent.prototype, "model", void 0);
__decorate([
    Input()
], NgxLabelForComponent.prototype, "field", void 0);
__decorate([
    HostBinding('class.ngx-label')
], NgxLabelForComponent.prototype, "ngxLabel", void 0);

let NgxValidatorForComponent = class NgxValidatorForComponent {
    constructor() {
        this.messages = [];
        this.ngxLabel = true;
    }
    set errors(value) {
        this.messages = [];
        if (value) {
            for (const item of Object.keys(value)) {
                this.messages.push(value[item].toString());
            }
        }
    }
};
NgxValidatorForComponent.ɵfac = function NgxValidatorForComponent_Factory(t) { return new (t || NgxValidatorForComponent)(); };
NgxValidatorForComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxValidatorForComponent, selectors: [["ngx-validator-for"]], hostVars: 2, hostBindings: function NgxValidatorForComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("ngx-validator", ctx.ngxLabel);
    } }, inputs: { errors: "errors" }, decls: 2, vars: 1, consts: [[1, "ngx-validator-child"], [4, "ngFor", "ngForOf"], [4, "ngIf"]], template: function NgxValidatorForComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, NgxValidatorForComponent_div_1_Template, 2, 1, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.messages);
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc3.TranslatePipe], encapsulation: 2 });
__decorate([
    HostBinding('class.ngx-validator')
], NgxValidatorForComponent.prototype, "ngxLabel", void 0);
__decorate([
    Input('errors')
], NgxValidatorForComponent.prototype, "errors", null);

var NgxValidatorDirective_1;
let NgxValidatorDirective = NgxValidatorDirective_1 = class NgxValidatorDirective {
    constructor(el) {
        this.el = el;
        this.validator = validateControl;
    }
    set sk(value) {
        this.dataModel = value;
    }
    validate(control) {
        return this.validator(control, this.dataModel);
    }
};
NgxValidatorDirective.ɵfac = function NgxValidatorDirective_Factory(t) { return new (t || NgxValidatorDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NgxValidatorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxValidatorDirective, selectors: [["", "ngx-validator", "", "ngModel", ""], ["", "ngx-validator", "", "formControl", ""], ["", "ngx-validator", "", "formControlName", ""]], inputs: { sk: ["ngx-validator", "sk"], field: "field" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALIDATORS, useExisting: NgxValidatorDirective_1, multi: true }
        ])] });
NgxValidatorDirective.ctorParameters = () => [
    { type: ElementRef }
];
__decorate([
    Input()
], NgxValidatorDirective.prototype, "field", void 0);
__decorate([
    Input('ngx-validator')
], NgxValidatorDirective.prototype, "sk", null);

let NgxValidatorModule = class NgxValidatorModule {
};
NgxValidatorModule.ɵfac = function NgxValidatorModule_Factory(t) { return new (t || NgxValidatorModule)(); };
NgxValidatorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxValidatorModule });
NgxValidatorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxValidatorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCustomTemplateForDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[ngxCustomTemplateFor]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }]; }, { ngxCustomTemplateFor: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDropdownForComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'ngx-dropdown-for',
                template: "<select\n    [(ngModel)]=\"value\"\n    [ngStyle]=\"{'color':'red'}\"\n    class=\"ngx-dropdown-child\">\n    <option\n        value=\"undefined\"\n        disabled\n        class=\"ngx-dropdown-child-default\"\n        selected\n        hidden\n        *ngIf=\"defaultItem\">\n        {{placeHolder}}\n    </option>\n    <ng-container *ngIf=\"valuePrimitive; else nonPrimitve\">\n        <option\n            *ngFor=\"let item of itemSource\"\n            [ngValue]=\"item[key]\">\n            {{item[text]}}\n        </option>\n    </ng-container>\n    <ng-template #nonPrimitve>\n        <option\n            *ngFor=\"let item of itemSource\"\n            [ngValue]=\"item\">\n            {{item[text]}}\n        </option>\n    </ng-template>\n</select>\n",
                providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: NgxDropdownForComponent_1, multi: true },
                    { provide: NG_VALIDATORS, useExisting: NgxDropdownForComponent_1, multi: true }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Injector }]; }, { ngxDropdown: [{
            type: HostBinding,
            args: ['class.ngx-dropdown']
        }], itemSource: [{
            type: Input
        }], valuePrimitive: [{
            type: Input
        }], defaultItem: [{
            type: Input
        }], templates: [{
            type: ContentChildren,
            args: [NgxCustomTemplateForDirective, { descendants: false }]
        }], field: [{
            type: Input
        }], key: [{
            type: Input
        }], text: [{
            type: Input
        }], ngModel: [{
            type: ViewChild,
            args: [NgModel, { static: false }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxFormForReactiveComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'ngx-form-for-reactive',
                template: "<form\n    #form=\"ngForm\"\n    (ngSubmit)=\"submit()\"\n    [autocomplete]=\"autoComplete\"\n    [formGroup]=\"_formGroup\">\n    <div\n        [ngClass]=\"cssClasses? cssClasses.group: 'ngx-form-for'\"\n        *ngFor=\"let item of propertyNames\">\n        <ng-container *ngIf=\"!item.template; else template\">\n            <ngx-label-for\n                [model]=\"_model\"\n                [field]=\"item.field\"\n                [ngClass]=\"cssClasses? cssClasses.label:''\"></ngx-label-for>\n            <ngx-input-for\n                [formControlName]=\"item.field\"\n                [model]=\"_model\"\n                [ngClass]=\"cssClasses? cssClasses.input:''\"></ngx-input-for>\n            <ngx-validator-for\n                [errors]=\"_formGroup.get(item.field)?.errors\"\n                [ngClass]=\"cssClasses? cssClasses.error: ''\">\n            </ngx-validator-for>\n        </ng-container>\n        <ng-template #template>\n            <!-- temporary form validation workaround. custom temlpate is not binded to form's controls and therefore, form validation doesn't work. help needed -->\n            <input\n                [formControlName]=\"item.field\"\n                [ngx-validator]=\"_model\"\n                style=\"display:none\">\n            <ng-container\n                [ngTemplateOutlet]=\"getTemplate(item.field)\"\n                [ngTemplateOutletContext]=\"{$implicit: {model: _model, form: form}}\">\n            </ng-container>\n        </ng-template>\n    </div>\n    <button\n        type=\"submit\"\n        [disabled]=\"form.invalid\"\n        class=\"btn btn-success\">\n        Submit\n    </button>\n</form>\n"
            }]
    }], function () { return []; }, { submitForm: [{
            type: Output
        }], model: [{
            type: Input
        }], formGroup: [{
            type: Input
        }], templates: [{
            type: ContentChildren,
            args: [NgxCustomTemplateForDirective, { descendants: false }]
        }], cssClasses: [{
            type: Input
        }], autoComplete: [{
            type: Input
        }], form: [{
            type: ViewChild,
            args: [NgForm, { static: false }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxFormForComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'ngx-form-for',
                template: "<form\n    #form=\"ngForm\"\n    (ngSubmit)=\"submit()\"\n    [autocomplete]=\"autoComplete\">\n    <div\n        [ngClass]=\"cssClasses?.group? cssClasses.group : 'ngx-form-for'\"\n        *ngFor=\"let item of propertyNames\">\n        <ng-container *ngIf=\"!item.template; else template\">\n            <ngx-label-for\n                [model]=\"_model\"\n                [field]=\"item.field\"\n                [ngClass]=\"cssClasses?.label ? cssClasses?.label: ''\"></ngx-label-for>\n            <ngx-input-for\n                [id]=\"item.field\"\n                [model]=\"_model\"\n                [(ngModel)]=\"_model[item.field]\"\n                [ngModelOptions]=\"{ name: item.field }\"\n                [field]=\"item.field\"\n                [ngClass]=\"cssClasses?.input ? cssClasses.input: ''\"></ngx-input-for>\n            <ngx-validator-for\n                [errors]=\"form.controls[item.field]?.errors\"\n                [ngClass]=\"cssClasses?.error ? cssClasses.error: ''\">\n            </ngx-validator-for>\n        </ng-container>\n        <ng-template #template>\n            <!-- temporary form validation workaround. custom temlpate is not binded to form's controls and therefore, form validation doesn't work. help needed -->\n            <input\n                [name]=\"item.field\"\n                [(ngModel)]=\"_model[item.field]\"\n                [ngx-validator]=\"_model\"\n                style=\"display:none\">\n            <ng-container\n                [ngTemplateOutlet]=\"getTemplate(item.field)\"\n                [ngTemplateOutletContext]=\"{$implicit: {model: _model, form: form}}\">\n            </ng-container>\n        </ng-template>\n    </div>\n    <button\n        type=\"submit\"\n        [disabled]=\"form.invalid\"\n        class=\"btn btn-success\">\n        Submit\n    </button>\n</form>\n"
            }]
    }], function () { return []; }, { submitForm: [{
            type: Output
        }], model: [{
            type: Input
        }], templates: [{
            type: ContentChildren,
            args: [NgxCustomTemplateForDirective, { descendants: false }]
        }], cssClasses: [{
            type: Input
        }], autoComplete: [{
            type: Input
        }], form: [{
            type: ViewChild,
            args: [NgForm, { static: false }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxInputForComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'ngx-input-for',
                template: "<ng-container [ngSwitch]=\"dataType\">\n    <ng-container *ngIf=\"!_template; else template\">\n        <a\n            [href]=\"value\"\n            *ngSwitchCase=\"DataTypeEnum.Url\"\n            class=\"ngx-input-child-url\"\n            [id]=\"field\">\n            {{name | translate}}\n        </a>\n        <input\n            type=\"password\"\n            *ngSwitchCase=\"DataTypeEnum.Password\"\n            [placeholder]=\"placeHolder | translate\"\n            [(ngModel)]=\"value\"\n            [id]=\"field\"\n            autocomplete=\"{{autocomplete}}\"\n            [disabled]=\"this.disabled\"\n            class=\"ngx-input-child\"\n            [readOnly]=\"readonly\">\n        <img\n            *ngSwitchCase=\"DataTypeEnum.ImageUrl\"\n            [src]=\"value\"\n            class=\"ngx-input-child-image\"\n            [id]=\"field\">\n        <input\n            type=\"file\"\n            *ngSwitchCase=\"DataTypeEnum.Upload\"\n            [placeholder]=\"placeHolder | translate\"\n            [(ngModel)]=\"value\"\n            [id]=\"field\"\n            autocomplete=\"{{autocomplete}}\"\n            [disabled]=\"this.disabled\"\n            class=\"ngx-input-child-upload\"\n            [readOnly]=\"readonly\">\n        <textarea\n            *ngSwitchCase=\"DataTypeEnum.MultilineText\"\n            [placeholder]=\"placeHolder | translate\"\n            [(ngModel)]=\"value\"\n            [id]=\"field\"\n            [disabled]=\"this.disabled\"\n            class=\"ngx-input-child-textarea\"\n            rows=\"5\"\n            [readOnly]=\"readonly\"></textarea>\n        <input\n            *ngSwitchDefault\n            type=\"text\"\n            [placeholder]=\"placeHolder | translate\"\n            [(ngModel)]=\"value\"\n            autocomplete=\"{{autocomplete}}\"\n            [id]=\"field\"\n            [disabled]=\"this.disabled\"\n            class=\"ngx-input-child\"\n            [readOnly]=\"readonly\"\n            [name]=\"field\">\n    </ng-container>\n    <ng-template #template>\n        <ng-container\n            [ngTemplateOutlet]=\"getTemplate()\"\n            [ngTemplateOutletContext]=\"{$implicit: model}\">\n        </ng-container>\n    </ng-template>\n</ng-container>\n",
                providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => NgxInputForComponent_1), multi: true },
                    { provide: NG_VALIDATORS, useExisting: NgxInputForComponent_1, multi: true }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Injector }]; }, { blurEvent: [{
            type: Output
        }], ngxInput: [{
            type: HostBinding,
            args: ['class.ngx-input']
        }], onFocusout: [{
            type: HostListener,
            args: ['focusout']
        }], templates: [{
            type: ContentChildren,
            args: [NgxCustomTemplateForDirective, { descendants: false }]
        }], field: [{
            type: Input
        }], dataItems: [{
            type: Input
        }], ngModel: [{
            type: ViewChild,
            args: [NgModel, { static: false }]
        }], formControlName: [{
            type: ViewChild,
            args: [FormControlName, { static: false }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxLabelForComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'ngx-label-for',
                template: "<label\r\n    for=\"{{field}}\"\r\n    class=\"ngx-label-child\">\r\n    {{reflectValue | translate}}\r\n</label>\r\n"
            }]
    }], function () { return []; }, { ngxLabel: [{
            type: HostBinding,
            args: ['class.ngx-label']
        }], model: [{
            type: Input
        }], field: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxValidatorForComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'ngx-validator-for',
                template: "<div class=\"ngx-validator-child\">\n    <div *ngFor=\"let message of messages\">\n        <ng-container *ngIf=\"message\">{{message | translate}}</ng-container>\n    </div>\n</div>\n"
            }]
    }], function () { return []; }, { ngxLabel: [{
            type: HostBinding,
            args: ['class.ngx-validator']
        }], errors: [{
            type: Input,
            args: ['errors']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxValidatorDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[ngx-validator][ngModel],[ngx-validator][formControl],[ngx-validator][formControlName]',
                providers: [
                    { provide: NG_VALIDATORS, useExisting: NgxValidatorDirective_1, multi: true }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { sk: [{
            type: Input,
            args: ['ngx-validator']
        }], field: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxValidatorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    TranslateModule
                ],
                declarations: [
                    NgxValidatorDirective,
                    NgxValidatorForComponent,
                    NgxLabelForComponent,
                    NgxInputForComponent,
                    NgxFormForReactiveComponent,
                    NgxFormForComponent,
                    NgxDropdownForComponent,
                    NgxCustomTemplateForDirective
                ],
                exports: [
                    NgxValidatorDirective,
                    NgxValidatorForComponent,
                    NgxLabelForComponent,
                    NgxInputForComponent,
                    NgxFormForReactiveComponent,
                    NgxFormForComponent,
                    NgxDropdownForComponent,
                    NgxCustomTemplateForDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxValidatorModule, { declarations: function () { return [NgxValidatorDirective, NgxValidatorForComponent, NgxLabelForComponent, NgxInputForComponent, NgxFormForReactiveComponent, NgxFormForComponent, NgxDropdownForComponent, NgxCustomTemplateForDirective]; }, imports: function () { return [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule]; }, exports: function () { return [NgxValidatorDirective, NgxValidatorForComponent, NgxLabelForComponent, NgxInputForComponent, NgxFormForReactiveComponent, NgxFormForComponent, NgxDropdownForComponent, NgxCustomTemplateForDirective]; } }); })();

/*
 * Public API Surface of ngx-validator
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Compare, Contains, CreditCard, Custom, DataType, DataTypeEnum, Email, MaxValue, MinValue, ModelState, Name, NgxDropdownForComponent, NgxFormForComponent, NgxFormForReactiveComponent, NgxInputForComponent, NgxLabelForComponent, NgxValidatorDirective, NgxValidatorForComponent, NgxValidatorModule, NgxValidatorService, NoForm, NotContains, Pattern, Placeholder, Range, ReadOnly, Required, RequiredIf, StringLength, configurable, getDecorators, ngxValidate, ElementBase as ɵa, ValueAccessorBase as ɵb, NgxCustomTemplateForDirective as ɵc };

